module.exports = __webpack_public_path__ + "static/media/falera.5d9249d4.jpg";